export default {
  init() {

    function initDynamicPPCUrlFix() {
      //Fix PPC
      if (window.IS_NITROPACK) {
        $('[onclick*="ppcClick"]').each(function () {
          const ppcClick = $(this).attr('onclick').split(',');

          if (ppcClick[2].includes('?#039;')) {
            ppcClick[2] = ppcClick[2].replace('?#039;', '\'');
          }

          $(this).attr('onclick', ppcClick.join(','));
        });
      }
    }

    function initDynamicContentLoad() {

      const referrer = document.referrer;
      if (!referrer || referrer.length === 0 || !referrer.includes('vendor-list') || !window.IS_NITROPACK)
        return;

      const productSlug = referrer.split('/')[3];
      const vendorSlug = window.vendorSlug || window.location.pathname.split('/')[1];

      function getBreadCrumbs() {

        $('.sh-breadcrumbs').remove();

        const breadCrumbsSkeleton = `<div class="sh-breadcrumbs">
    <div class="container-fluid" style="display:flex;">
              <span class="breadcrumb" style="display:flex;">
                      <p class="skeleton-loader" style="width: 48px;height: 12px;  margin: auto;"></p>
            <span class="delimiter">/</span>
                  </span>
              <span class="breadcrumb" style="display:flex;">
                      <p class="skeleton-loader" style="width: 240px;height: 12px; margin: auto; "></p>
            <span class="delimiter">/</span>
                  </span>
              <span class="breadcrumb" style="display:flex;">
                      <p class="skeleton-loader" style="width: 120px;height: 12px; margin: auto;"></p>
                  </span>
          </div>
  </div>`;

        $('header').after(breadCrumbsSkeleton);
        $('.sh-hero-visit-wrap').hide();
        $.ajax({
          url: window.ajax.url,
          type: 'get',
          dataType: 'json',
          data: {
            action: 'get_referral_info',
            productSlug: productSlug,
            vendorSlug: vendorSlug,
          },
          success: function (result) {

            let breadCrumbsHtml = `<div class="sh-breadcrumbs">
    <div class="container-fluid">
              <span class="breadcrumb">
                      <a href="/">Home</a>
            <span class="delimiter">/</span>
                  </span>
              <span class="breadcrumb">
                      <a href="[product_link]">[product_title]</a>
            <span class="delimiter">/</span>
                  </span>
              <span class="breadcrumb">
                      <span>[page_title]</span>
                  </span>
          </div>
  </div>`;

            const {data} = result;
            const pageTitle = $('.vendor-title h1').text();
            breadCrumbsHtml = breadCrumbsHtml.replace('[page_title]', pageTitle).replace('[product_title]', data.productName).replace('[product_link]', `/${productSlug}/vendor-list`)
            $('.sh-breadcrumbs').remove();
            $('header').after(breadCrumbsHtml);
            changeAltText(data.productName)

            if (!data.isPpc) {
              $('.sh-visit-website-wrap').remove();
              $('.sh-hero-visit-wrap').remove();

              const logoHtml = $('#sh-sticky-header .logo-wrapper a').html();
              $('#sh-sticky-header .logo-wrapper').html(logoHtml);

              const titleHtml = $('#sh-sticky-header .vendor-title a').html();
              $('#sh-sticky-header .vendor-title').html(titleHtml);

              let heroButtonClick = '';
              const vendorTitle = $('#sh-sticky-header .vendor-title h1').text();
              if (data.productID) {
                heroButtonClick = `openRequestInfoPopUp(this, [{'slug':'${vendorSlug}'}], '${productSlug}', ['${vendorTitle}'])`;

              } else {
                heroButtonClick = `openRequestInfoPopUp(this, [{'slug':'${vendorSlug}'}],'', ['${vendorTitle}'])`
              }

              const btnImg = $('#sh-sticky-header .hero-buttons img').attr('src');
              $('#sh-sticky-header .hero-buttons').html(`
                    <button type="button" class="sh-button-primary get-in-contact-button trc-vp-button"
                            onclick="${heroButtonClick}">
                            <img src="${btnImg}" alt="&dollar;"/>
                            <span class="d-inline-block">Get a Quote</span>
                    </button>`);
            } else {
              $('.sh-hero-visit-wrap').show();
            }
          },
        });
      }

      function getAlternatives() {

        const altSkeleton = `  <div style="display: flex;flex-direction: row; gap: 16px; margin-bottom: 24px">
      <div style="width: 150px; height: 86px; border-radius: 16px" class="skeleton-loader"></div>
      <div style="display: flex;flex-direction: column; gap: 16px">
        <div style="display: flex; flex-direction: column; gap: 4px">
          <div style="width: 160px; height:16px" class="skeleton-loader"></div>
          <div style="width: 108px; height: 10px" class="skeleton-loader"></div>
        </div>
        <div style="width: 124px; height: 12px" class="skeleton-loader"></div>
      </div>
    </div>`;

        const alternativesEl = $('#section-alternatives');
        alternativesEl.find('.sh-alternatives-wrap').remove();

        const competitorsEl = $('.sh-competitors-wrapper');

        $('#section-alternatives .sh-alternatives-section-title').after(`
         <div class="sh-alternatives-wrap sh-skeleton-loading" style="display: flex; flex-direction: column">
            ${altSkeleton}${altSkeleton}${altSkeleton}${altSkeleton}${altSkeleton}</div>`)

        const competitorsSkeleton = '<a href="#" class="sh-competitor"><div alt="Wellness Platform/CHC Wellbeing" style="\n' +
          '    width: 32px;\n' +
          '    height: 32px;\n' +
          '" class="skeleton-loader"></div>\n' +
          '        <p class="skeleton-loader" style="\n' +
          '    width: 100px;\n' +
          '    height: 15px;\n' +
          '"></p></a>';
        competitorsEl.html(competitorsSkeleton + competitorsSkeleton + competitorsSkeleton)

        $.ajax({
          url: window.ajax.url,
          type: 'get',
          dataType: 'json',
          data: {
            action: 'get_dynamic_content',
            productSlug: productSlug,
            vendorSlug: vendorSlug,
          },
          success: function (result) {
            const {data = ''} = result;
            $('.sh-alternatives-wrap.sh-skeleton-loading').remove();
            alternativesEl.find('.sh-alternatives-section-title').after(data.alternatives);
            competitorsEl.html(data.competitors)
          },
          error() {
            $('.sh-alternatives-wrap.sh-skeleton-loading').remove();
          },
        });
      }

      function adjustProductSlider() {

        const sliderSkeleton = `<div class="sh-slider-body-wrap sh-skeleton-loading"
         style="padding: 24px; gap: 24px; display: flex; flex-direction: column;">
      <div style="display: flex; flex-direction: row; gap:20px">
        <div class="skeleton-loader" style="width: 260px; max-width: 100%; height: 90px; border-radius: 12px"></div>
        <div class="skeleton-loader" style="width: 260px; max-width: 100%; height: 90px; border-radius: 12px"></div>
        <div class="skeleton-loader" style="width: 260px; max-width: 100%; height: 90px; border-radius: 12px"></div>
      </div>
      <div style="display: flex; flex-direction: column; gap: 12px">
        <div style="width: 300px; max-width: 100%; height: 24px" class="skeleton-loader"></div>
        <div style="width: 605px; max-width: 100%; height: 16px" class="skeleton-loader"></div>
        <div style="width: 684px; max-width: 100%; height: 16px" class="skeleton-loader"></div>
        <div style="width: 420px; max-width: 100%; height: 16px" class="skeleton-loader"></div>
        <div style="width: 323px; max-width: 100%; height: 16px" class="skeleton-loader"></div>
      </div>
      <div style="width: 704px; max-width: 100%; height: 200px; border-radius: 16px" class="skeleton-loader">
      </div>
      <div>
        <div style="width: 300px;max-width: 100%; height: 24px; margin-bottom: 10px" class="skeleton-loader"></div>
        <div style="display: flex; flex-direction: row; gap: 30px; overflow: hidden">
          <div style="display: flex;  flex-direction: column; gap: 10px">
            <div style="width:  326px; max-width: 100%; height: 16px" class="skeleton-loader"></div>
            <div style="width: 240px; max-width: 100%; height: 16px" class="skeleton-loader"></div>
            <div style="width: 280px; max-width: 100%; height: 16px" class="skeleton-loader"></div>
          </div>
          <div style="display: flex; flex-direction: column; gap: 10px">
            <div style="width: 326px; max-width: 100%; height: 16px" class="skeleton-loader"></div>
            <div style="width: 240px; max-width: 100%; height: 16px" class="skeleton-loader"></div>
            <div style="width: 280px; max-width: 100%; height: 16px" class="skeleton-loader"></div>
          </div>
        </div>
      </div>
    </div>`;

        $('.sh-slider-body-wrap').prepend(sliderSkeleton);
        $('.sh-slider-body-wrap').attr('style', `visibility: hidden;
    height: 0px;
    margin: 0;
    padding: 0px;`
        );

        const productSliderItem = $(`[data-product_slug="${productSlug}"]`);
        if (productSliderItem) {
          productSliderItem.prependTo('.sh-product-slider');
          setTimeout(function () {
            $('.sh-slider-body-wrap').attr('style', '');
            $('.sh-slider-body-wrap.sh-skeleton-loading').remove();
            $(`[data-product_slug="${productSlug}"]`).click();
          }, 100);

          if ($(`[data-product_slug="${productSlug}"]`).data('product-istop')) {
            $('#sh-sticky-header .sh-product-ribbon').removeClass('sh-hidden');
          }
        }
      }

      function changeAltText(productTitle) {
        const imgSelectors = '.logo-wrapper img, .sh-competitor img, .sh-alternatives-logo img'
        $(imgSelectors).each(function () {
          const currentAlt = $(this).attr('alt');
          $(this).attr('alt', `${productTitle}/${currentAlt}`);
        })
      }

      function changePPC() {
        $('[onclick*="ppcClick"]').each(function () {
          const ppcClick = $(this).attr('onclick').split(',');
          ppcClick[2] = `'|**|${productSlug}'`;
          $(this).attr('onclick', ppcClick.join(','));
        });
      }

      function changeRequestInfoPopup() {
        $('[onclick*="openRequestInfoPopUp"]').each(function () {
          const requestInfoClick = $(this).attr('onclick').split(',');
          requestInfoClick[2] = `'${productSlug}'`;
          $(this).attr('onclick', requestInfoClick.join(','));
        });
      }

      try {
        getBreadCrumbs();
        getAlternatives();
        adjustProductSlider();
        changePPC();
        changeRequestInfoPopup();
      } catch (e) {
        console.log('e', e)
      }
    }

    //media gallery start
    function initMediaGallery() {
      const galleryData = window.mediaGallery;

      if (!galleryData || !galleryData.length) {
        $('#sh-anchors a[href="#section-media"]').parent().hide();
        return;
      }

      const scrollStep = $('#imagesWrap img').outerWidth() * 2;
      let scrollPosition = 0;
      const maxLength = ($('#imagesWrap img').length - 1) * $('#imagesWrap img').outerWidth();

      $('.btnNext').click(() => {

        scrollPosition += scrollStep;
        if (scrollPosition > maxLength)
          scrollPosition = maxLength;

        $('.btnPrev').removeClass('disabled')
        if (scrollPosition > maxLength - (scrollStep * 2))
          $('.btnNext').addClass('disabled')
        else
          $('.btnNext').removeClass('disabled')

        $('#imagesWrap').animate({scrollLeft: scrollPosition}, 200);
      })

      $('.btnPrev').click(() => {
        if (scrollPosition === maxLength)
          scrollPosition -= scrollStep * 3;
        else
          scrollPosition -= scrollStep;

        if (scrollPosition < 0)
          scrollPosition = 0;

        $('.btnNext').removeClass('disabled')
        if (scrollPosition === 0)
          $('.btnPrev').addClass('disabled')
        else
          $('.btnPrev').removeClass('disabled')

        $('#imagesWrap').animate({scrollLeft: scrollPosition}, 200);

      });

      $('#imagesWrap img').on('click', function () {
        const imageIndex = $(this).attr('data-imageIndex');

        if (galleryData[imageIndex].type == 1) {
          $('#mainPreview').html(` <iframe src="https://player.vimeo.com/video/${galleryData[imageIndex].link}" width="752" height="432"
                  allow="autoplay; fullscreen" allowFullScreen></iframe>`);

        } else if (galleryData[imageIndex].type == 0) {
          $('#mainPreview').html(` <iframe src="https://www.youtube.com/embed/${galleryData[imageIndex].link}" width="752" height="432"
                  allow="autoplay; fullscreen" allowFullScreen></iframe>`);
        } else {
          const imageUrl = `https://d2pczs67u7x6c8.cloudfront.net/fit/752x432/${galleryData[imageIndex].id}`;
          $('#mainPreview').html(`<img alt='${galleryData[imageIndex].title}' src='${imageUrl}' data-index="${imageIndex}"/>`);
        }

        $('#galleryTitle').hide();
        $('#galleryDesc').hide();

        if (galleryData[imageIndex].title) {
          $('#galleryTitle').text(galleryData[imageIndex].title);
          $('#galleryTitle').show();
        }

        if (galleryData[imageIndex].description) {
          $('#galleryDesc').text(galleryData[imageIndex].description);
          $('#galleryDesc').show();
        }

        $('#imagesWrap img').removeClass('active');
        $(this).addClass('active')
      });

      if ($('#imagesWrap img') && $('#imagesWrap img')[0])
        $('#imagesWrap img')[0].click();

      $(document).on('click', '#mainPreview img', function () {
        const galleryData = window.mediaGallery;
        const env = window.envUrl;
        const mediaIndex = $(this).data('index');

        let galleryElements = [];
        galleryData.map(item => {

          const subHtml = `<h4>${item.title}</h4><p>${item.description}</p>`;

          if (item.id)
            galleryElements.push({
              src: `${env}/fit/600x600/${item.id}`,
              thumb: `${env}/fit/304x182/${item.id}`,
              subHtml: subHtml,
            })

          if (item.type == 1 && item.link) {
            galleryElements.push({
              src: `https://player.vimeo.com/video/${item.link}`,
              subHtml: subHtml,
              iframe: true,
            })
          }

          if (item.type == 0 && item.link) {
            galleryElements.push({
              src: `https://www.youtube.com/embed/${item.link}`,
              subHtml: subHtml,
              iframe: true,
            })
          }
        });


        $(this).lightGallery({
          dynamic: true,
          dynamicEl: galleryElements,
          loadYoutubeThumbnail: true,
          youtubeThumbSize: 'default',
          loadVimeoThumbnail: true,
          vimeoThumbSize: 'thumbnail_medium',
          thumbnail: false,
          rotate: false,
          flipHorizontal: false,
          flipVertical: false,
          share: false,
          autoplay: false,
          autoPlay: false,
          actualSize: false,
          pager: true,
        });

        if (mediaIndex)
          setTimeout(function () {
            $('.lg-pager-outer .lg-pager-cont')[mediaIndex].click();
          }, 100)

      });

    }

    initMediaGallery();
    initDynamicPPCUrlFix();
    initDynamicContentLoad();

    const headerId = '#sh-sticky-header';

    function updateActiveMenuItem() {
      const scrollPosition = $(window).scrollTop();

      $('.section-main section').each(function () {
        const offset = $(this).offset().top - 65;
        const height = $(this).outerHeight();
        const id = $(this).attr('id');
        if (scrollPosition >= offset && scrollPosition < (offset + height)) {
          $('.sh-anchors .anchor a').removeClass('active');
          $('a[href="#' + id + '"]').addClass('active');
        }
      });
    }

    $(window).on('resize scroll', function () {
      updateActiveMenuItem($(headerId).outerHeight()); // Update the active menu item with the new header height
    });


    $('.sh-anchors .anchor a').on('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const targetId = $(this).attr('href');
      const $targetSection = $(targetId);
      const initialTargetOffset = $targetSection.offset().top - $(headerId).outerHeight();

      if (targetId === $($('.section-main section')[0]).attr('id')) {
        $('html, body').animate({
          scrollTop: initialTargetOffset + 30,
        }, {
          duration: 800,
        });
      } else {
        $('html, body').animate({
          scrollTop: initialTargetOffset + 30,
        }, {
          duration: 800,
          step: function (now, fx) {
            if (fx.prop === 'scrollTop') {
              const dynamicHeaderHeight = $(headerId).outerHeight();
              updateActiveMenuItem(dynamicHeaderHeight);
              const dynamicTargetOffset = $targetSection.offset().top - dynamicHeaderHeight;
              fx.end = dynamicTargetOffset + 30;
            }
          },
        });
      }

    });


    /*Sticky Menu*/
    //Pre-select active anchor if hash exists in the URL
    const hash = window.location.hash;
    if (hash) {
      $('.sh-anchors .anchor a').removeClass('active');
      $('.sh-anchors .anchor a[href="' + hash + '"]').addClass('active');
    }

    //Sticky Header

    $(window).on('scroll', function () {
      if ($(document).scrollTop() < 10)
        $('#sh-sticky-header').removeClass('sticky-selection');
      else
        $('#sh-sticky-header').addClass('sticky-selection');
    });


    // let sticky = document.getElementById('sh-sticky-header').offsetTop;
    //
    // window.onscroll = function () {
    //   if (window.scrollY > (sticky - 10)) {
    //     let scrollY = window.scrollY;
    //     $('#sh-sticky-header').addClass('sticky-selection');
    //     if (window.scrollY <= sticky) {
    //       window.scroll(window.scrollX, scrollY);
    //       //jQuery("#sh-sticky-header").height()
    //     }
    //   } else {//104<=73 Not sticky
    //     $('#sh-sticky-header').removeClass('sticky-selection');
    //   }
    // };

    /*Product Slider*/

    let sliderProductScrollPosition = 0;
    let sliderProductSize = 280;
    //On slider click
    $('.sh-product-tile').click(function (e) {
      if ($(e.target).parent().hasClass('sh-product-ribbon'))
        return

      let productDescription = $(this).data('description');
      let productFeatures = $(this).data('features');
      let productMinGroupSize = $(this).data('min_group_size');
      let productLivesServiced = $(this).data('lives_serviced');
      let productRfiQuestionsCount = $(this).data('rfi_questions_count');
      let productFiltersCount = $(this).data('product_filters_count');

      $('#sh-product-min-group-size').html(productMinGroupSize);
      $('#sh-product-lives-serviced').html(productLivesServiced);
      $('#sh-product-rfi-questions-count').html(productRfiQuestionsCount);
      $('#sh-product-filters-count').html(productFiltersCount);

      //Description
      if ($.trim(productDescription) == '' || wordCount(productDescription) <= 50) {
        if (!$('#sh-product-description .sh-show-more').hasClass('sh-hidden')) {
          $('#sh-product-description .sh-show-more').addClass('sh-hidden');
        }
      } else {
        if ($('#sh-product-description .sh-show-more').hasClass('sh-hidden')) {
          $('#sh-product-description .sh-show-more').removeClass('sh-hidden');
          $('#sh-modal-product-description .sh-modal-content').html(productDescription);
        }
      }
      $('#sh-product-short-description').html(limitWords(productDescription, 50));

      //Features
      let featuresLength = Object.keys(productFeatures).length;

      let featuresHtml = '';
      if (featuresLength > 0) {
        featuresHtml = getFeaturesHtml(productFeatures);
      }

      $('#sh-product-features-wrapper').removeClass('sh-hidden');

      if (productFiltersCount == 0) {
        $('#sh-product-features-wrapper').addClass('sh-hidden');
      } else if (featuresLength == 0 && productFiltersCount > 0) {
        $('#sh-product-features').addClass('sh-hidden');
        $('#sh-product-features-empty').removeClass('sh-hidden');
      } else if (featuresLength > 0 && featuresLength <= 6) {
        $('#sh-product-features-empty').addClass('sh-hidden');
        $('#sh-product-features').removeClass('sh-hidden');

        $('#sh-product-features-wrapper .sh-product-features-content').html(featuresHtml);//Add features in the block


        if (!$('#sh-product-features-wrapper .sh-show-more').hasClass('sh-hidden')) {
          $('#sh-product-features-wrapper .sh-show-more').addClass('sh-hidden');
        }
      } else {
        let featuresPopupHtml = getFeaturesPopupHtml(productFeatures);
        $('#sh-product-features-wrapper .sh-product-features-content').html(featuresHtml);//Add features in the block
        $('#sh-product-features-wrapper .sh-show-more').html('Show all ' + featuresLength + ' features');
        $('#sh-modal-product-features .sh-modal-content').html(featuresPopupHtml);//Add all features in the modal

        $('#sh-product-features-empty').addClass('sh-hidden');
        $('#sh-product-features').removeClass('sh-hidden');
        if ($('#sh-product-features-wrapper .sh-show-more').hasClass('sh-hidden')) {
          $('#sh-product-features-wrapper .sh-show-more').removeClass('sh-hidden');
        }

        if ($('#sh-product-features-wrapper').hasClass('sh-hidden')) {
          $('#sh-product-features-wrapper').removeClass('sh-hidden');
        }
      }

      //Active slide change
      $('.sh-product-tile').removeClass('sh-active');
      $(this).addClass('sh-active');


    });

    function setProductSliderPosition() {
      const currentActiveSlide = $('#sh-slider .sh-product-tile.sh-selected');


      let siblingsBefore = currentActiveSlide.prevAll().length;
      sliderProductScrollPosition = (siblingsBefore * sliderProductSize);
      if (siblingsBefore === 0) {
        sliderProductScrollPosition = 0;
      }
      $('.sh-slider-wrapper').animate({scrollLeft: sliderProductScrollPosition}, 10);
    }

    //On arrows click
    //On right arrow
    $('.sh-product-slider-nav .sh-slide-right').click(function () {
      const next = $('#sh-slider .sh-product-tile.sh-selected').next();
      if (next.length > 0) {
        $('#sh-slider .sh-product-tile.sh-selected').removeClass('sh-selected');
        next.addClass('sh-selected');
        setProductSliderPosition();
      }
    });

    //On left arrow click
    $('.sh-product-slider-nav .sh-slide-left').click(function () {
      const prev = $('#sh-slider .sh-product-tile.sh-selected').prev();
      if (prev.length > 0) {
        $('#sh-slider .sh-product-tile.sh-selected').removeClass('sh-selected');
        prev.addClass('sh-selected');
        setProductSliderPosition();
      }
    });

    //Get HTML for features in the block
    function getFeaturesHtml(features) {
      let html = '';

      html += '<div class="sh-grid-50">';
      for (let p1 = 0; p1 < 3; p1++) {
        if (features[p1] !== undefined) {
          html +=
            '<span class="sh-checklist-item">' +
            '<img src="/app/themes/shortlister/dist/images/icons/check.svg" alt="&check;" />' +
            '<h4>' + features[p1] + '</h4>' +
            '</span>';
        }
      }
      html += '</div>';

      html += '<div class="sh-grid-50">';
      for (let p2 = 3; p2 < 6; p2++) {
        if (features[p2] !== undefined) {
          html +=
            '<span class="sh-checklist-item">' +
            '<img src="/app/themes/shortlister/dist/images/icons/check.svg" alt="&check;" />' +
            '<h4>' + features[p2] + '</h4>' +
            '</span>';
        }
      }
      html += '</div>';

      return html;
    }

    //Get HTML for features in the popup
    function getFeaturesPopupHtml(features) {
      let html = '';

      features.forEach(function (feature) {
        html +=
          '<span class="sh-checklist-item">' +
          '<img src="/app/themes/shortlister/dist/images/icons/check.svg" alt="&check;" />' +
          '<h4>' + feature + '</h4>' +
          '</span>';
      });

      return html;
    }

    //Limit words in string
    function limitWords(inputString, limit) {
      inputString = $.trim(inputString.replace(/\s+/g, ' '));
      var words = inputString.split(' ');

      if (words.length > limit) {
        words = words.slice(0, limit);
        var resultString = words.join(' ');

        return resultString + '...';
      }

      return inputString;
    }

    //Words count
    function wordCount(inputString) {
      inputString = inputString.trim().replace(/\s+/g, ' ');
      var words = inputString.split(' ');
      return words.length;
    }

    /*Resources slider*/

    let sliderResourcesScrollPosition = 0;
    let sliderResourcesSize = 248;
    let sliderResourcesOffset = 0;
    let sliderResourcesDuration = 200;
    //On arrows click
    //On right arrow
    $('#sh-slider-resources .sh-resource-slider-nav .sh-slide-right').click(function () {
      //Update active slider
      let activeSlider = $('#sh-slider-resources .sh-resource-tile.sh-active');
      let activePagination = $('#sh-slider-resources .sh-resource-slider-pagination-item.sh-active');
      if (activeSlider.next().length != 0) {
        $('#sh-slider-resources .sh-resource-tile').removeClass('sh-active');
        $('#sh-slider-resources .sh-resource-slider-pagination-item').removeClass('sh-active');
        activeSlider.next().addClass('sh-active');
        activePagination.next().addClass('sh-active');

        //Scroll slider
        updateResourcesSliderPosition();
        $('#sh-slider-resources .sh-slider-resource-wrapper').animate({scrollLeft: sliderResourcesScrollPosition}, sliderResourcesDuration);
      }
    });

    //On left arrow click
    $('#sh-slider-resources .sh-resource-slider-nav .sh-slide-left').click(function () {
      //Update active slider
      let activeSlider = $('#sh-slider-resources .sh-resource-tile.sh-active');
      let activePagination = $('#sh-slider-resources .sh-resource-slider-pagination-item.sh-active');
      if (activeSlider.prev().length != 0) {
        $('#sh-slider-resources .sh-resource-tile').removeClass('sh-active');
        $('#sh-slider-resources .sh-resource-slider-pagination-item').removeClass('sh-active');
        activeSlider.prev().addClass('sh-active');
        activePagination.prev().addClass('sh-active');

        //Scroll slider
        updateResourcesSliderPosition();
        $('#sh-slider-resources .sh-slider-resource-wrapper').animate({scrollLeft: sliderResourcesScrollPosition}, sliderResourcesDuration);
      }
    });

    //On pagination click
    $('#sh-slider-resources .sh-resource-slider-pagination-item').click(function () {
      let clickedPage = $(this).data('id');

      $('#sh-slider-resources .sh-resource-tile').removeClass('sh-active');
      $('#sh-slider-resources .sh-resource-slider-pagination-item').removeClass('sh-active');
      $(this).addClass('sh-active');
      $('#' + clickedPage).addClass('sh-active');

      scrollPaginationResourcesSlider();
    });

    function updateResourcesSliderPosition() {
      let siblingsBefore = $('#sh-slider-resources .sh-resource-tile.sh-active').prevAll().length;
      sliderResourcesScrollPosition = (siblingsBefore * sliderResourcesSize) + sliderResourcesOffset;
    }

    function scrollPaginationResourcesSlider() {
      updateResourcesSliderPosition();
      $('#sh-slider-resources .sh-slider-resource-wrapper').animate({scrollLeft: sliderResourcesScrollPosition}, sliderResourcesDuration);
    }

    //Here start open lead magnet from
    let lastPopup;
    window.openLeadMagnetPopUp = function (button, vendors = [], download, doc_title) {
      lastPopup = $(button).parents('.popup');
      lastPopup.addClass('hidden');
      $('body').css('top', '-' + document.documentElement.scrollTop + 'px').addClass('disable-scroll');
      $('iframe[title="recaptcha challenge expires in two minutes"]').eq(1).parent().css('top', '10vh');
      $('.request-info-popup .loader').removeClass('hidden');
      $('.request-info-popup').removeClass('hidden');
      $('.popup-request-form').removeClass('hidden');

      $.ajax({
        url: window.ajax.url,
        type: 'get',
        dataType: 'json',
        data: {
          action: 'hub_spot_form',
          vendors: vendors.map(vendor => {
            return {'slug': vendor.slug};
          }),
          download: download,
          document_name: doc_title,
        },
        success: function (result) {
          $('.popup-request-form').empty().append(result.data.form);
          let scriptContainer = document.getElementsByClassName('popup-request-form');
          let script = scriptContainer[0].getElementsByTagName('script');

          if (result.data.evaluate) {
            eval(script[0].innerHTML);
          }
          setTimeout(function () {
            $('body > div:last-child > div:last-child').css('top', $('body').css('top').replace('-', ''));
            $('body > div:nth-last-child(2) > div:last-child').css('top', $('body').css('top').replace('-', ''));
          }, 2000);

          $('.request-info-popup .loader').addClass('hidden');
        },
      });
    }

    //One vs One
    function postNonObjects(path, parameters) {
      let form = $('<form></form>');

      form.attr('method', 'post');
      form.attr('action', path);

      $.each(parameters, function (key, value) {
        var field = $('<input></input>');

        field.attr('type', 'hidden');
        field.attr('name', key);
        field.attr('value', value);

        form.append(field);
      });

      //The form needs to be a part of the document in
      //order for us to be able to submit it.
      $(document.body).append(form);
      form.submit();
    }

    window.postToOneVsOnePage = function (url, productSlug, event) {
      event.preventDefault();
      let params = {
        'product-slug': productSlug,
      }

      postNonObjects('/compare/' + url, params);
    }

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
